import { render, staticRenderFns } from "./openPlatform.vue?vue&type=template&id=5b1a4f60&scoped=true&"
import script from "./openPlatform.vue?vue&type=script&lang=js&"
export * from "./openPlatform.vue?vue&type=script&lang=js&"
import style0 from "./openPlatform.vue?vue&type=style&index=0&id=5b1a4f60&prod&lang=scss&scoped=true&"
import style1 from "./openPlatform.vue?vue&type=style&index=1&id=5b1a4f60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a4f60",
  null
  
)

export default component.exports